import { createSlice } from '@reduxjs/toolkit';

const redirectURLSlice = createSlice({
  name: 'redirectURL',
  initialState: { redirectURL: '/objectives' },
  reducers: {
    setRedirectURL: (state, { payload: { url } }) => {
      state.redirectURL = url;
    }
  }
});

export const { setRedirectURL } = redirectURLSlice.actions;
export default redirectURLSlice.reducer;

export const redirectURL = state => state.redirectURLSlice.redirectURL;